import { HttpErrorResponse } from '@angular/common/http';

import { userFacingDetail } from '@abook-ui/utils/user-facing-detail';

/**
 * API'ets begrundelse for en afvist skrivning, hvis den er skrevet til brugeren — ellers `null`.
 *
 * En 400 er kun "brugerrettet", når API'et har sat `userFacing` på problem-svaret
 * (`UserFacingBadRequestException`); resten af API'ets 400'ere er engelske og tekniske.
 * `AuthInterceptor` viser en brugerrettet begrundelse i en snackbar af sig selv, så et kaldsted, der
 * fanger fejlen, kan bruge denne til at lade være med at lægge sin egen generiske besked oveni.
 */
export function userFacingRejection(error: unknown): string | null {
  return error instanceof HttpErrorResponse && error.status === 400
    ? userFacingDetail(error)
    : null;
}
